<template>
  <div>
    <div class="bk-title">{{ title }}</div>
    <div class="list">
      <div class="up">
        <div class="item" v-for="(v, k) in list['up']" :key=k @click="$router.push({path:`/plate/${v.HqTypeCode}/${v.ProdCode}.html`})">
          <div class="name">{{ v.ProdName }}</div>
          <div class="percent" :class="{'red': v.PxChangeRate > 0, 'green': v.PxChangeRate < 0}">{{ (v.PxChangeRate > 0 ? '+' : '') + (v.PxChangeRate / 100).toFixed(2) + '%' }}</div>
          <div class="desp">
            <span class="db">{{ v.RiseFirstGrp[0].ProdName }}</span>
            <span class="db-percent" :class="{'red': v.RiseFirstGrp[0].PxChangeRate > 0, 'green': v.RiseFirstGrp[0].PxChangeRate < 0}">{{ (v.RiseFirstGrp[0].PxChangeRate > 0 ? '+' : '') + (v.RiseFirstGrp[0].PxChangeRate / 100).toFixed(2) + '%' }}</span>
          </div>
        </div>
      </div>
      <div class="down">
        <div class="item" v-for="(v, k) in reverseDownList" :key=k @click="$router.push({path:`/plate/${v.HqTypeCode}/${v.ProdCode}.html`})">
          <div class="name">{{ v.ProdName }}</div>
          <div class="percent" :class="{'red': v.PxChangeRate > 0, 'green': v.PxChangeRate < 0}">{{ (v.PxChangeRate > 0 ? '+' : '') + (v.PxChangeRate / 100).toFixed(2) + '%' }}</div>
          <div class="desp">
            <span class="db">{{ v.RiseFirstGrp[0].ProdName }}</span>
            <span class="db-percent" :class="{'red': v.RiseFirstGrp[0].PxChangeRate > 0, 'green': v.RiseFirstGrp[0].PxChangeRate < 0}">{{ (v.RiseFirstGrp[0].PxChangeRate > 0 ? '+' : '') + (v.RiseFirstGrp[0].PxChangeRate / 100).toFixed(2) + '%' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="sep"></div>
    <div class="more" @click="goToRank">
      <span>查看更多</span>
      <img src="@/assets/more.png">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Object,
      required: true
    },
    tab: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  },
  computed: {
    reverseDownList() {
      console.log(this.list.up)
      return this.list.down.slice().reverse()
    }
  },
  methods: {
    goToRank() {
      this.$router.push({
        path: `/bkRank.html`,
        query: {
          tab: this.tab
        }
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
.bk-title
  height .38rem
  margin-left .12rem
  padding .09rem 0
  box-shadow 0px 1px 0px 0px #EBEBEB
  box-sizing border-box
  font-size .14rem
  color #666666
.list
  height 1.66rem
.more
  height .4rem
  text-align center
  font-size .14rem
  color #666666
  line-height .4rem
  img
    margin-left .04rem
.up,.down
  height .83rem
  display flex
.item
  flex 1
.sep
  height .01rem
  margin 0 .12rem
  box-shadow:0px 1px 0px 0px rgba(235,235,235,1);
.item
  display flex
  flex-direction column
  justify-content center
  align-items center
  .name
    color #333333
    font-size .16rem
    white-space nowrap
    font-family PingFangSC-Regular,PingFang SC
  .percent
    font-size .2rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
  .desp
    font-size .12rem
    .db
      margin-right .04rem
      color #666666
      font-family PingFangSC-Regular,PingFang SC
    .db-percent
      font-weight bold
      font-family DINAlternate-Bold,DINAlternate
.red
  color #F43737
.green
  color #1BAA3C
</style>